module.exports = __webpack_public_path__ + "static/media/lock.56071aee.svg";